var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
/**
 * 过滤ref
 */
export function fillRef(ref, node) {
    if (typeof ref === 'function') {
        ref(node);
    }
    else if (typeof ref === 'object' && ref && 'current' in ref) {
        ;
        ref.current = node;
    }
}
/**
 * 将ref合并到一个ref函数中以支持ref传递
 */
export function composeRef() {
    var refs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        refs[_i] = arguments[_i];
    }
    return function (node) {
        refs.forEach(function (ref) {
            fillRef(ref, node);
        });
    };
}
var ALL_HANDLERS = [
    'onClick',
    'onMouseDown',
    'onTouchStart',
    'onMouseEnter',
    'onMouseLeave',
    'onFocus',
    'onBlur',
    'onContextMenu',
];
var Trigger = /** @class */ (function (_super) {
    __extends(Trigger, _super);
    function Trigger(props) {
        var _this = _super.call(this, props) || this;
        ALL_HANDLERS.forEach(function (h) {
            _this["fire" + h] = function (e) {
                _this.fireEvents(h, e);
            };
        });
        return _this;
    }
    Trigger.prototype.fireEvents = function (type, e) {
        var childCallback = this.props.children.props[type];
        if (childCallback) {
            childCallback(e);
        }
        var callback = this.props[type];
        if (callback) {
            callback(e);
        }
    };
    Trigger.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, _b = _a.className, className = _b === void 0 ? '' : _b;
        var child = React.Children.only(children);
        var newChildProps = {
            key: 'trigger',
        };
        newChildProps.onClick = function (e) {
            _this.fireEvents('onClick', e);
        };
        newChildProps.onMouseEnter = function (e) {
            _this.fireEvents('onMouseEnter', e);
        };
        newChildProps.onMouseLeave = function (e) {
            _this.fireEvents('onMouseLeave', e);
        };
        newChildProps.onFocus = function (e) {
            _this.fireEvents('onMouseLeave', e);
        };
        newChildProps.onKeyPress = function (e) {
            _this.fireEvents('onMouseLeave', e);
        };
        if (child && child.props && child.props.className) {
            newChildProps.className = className;
        }
        var cloneProps = __assign({}, newChildProps);
        cloneProps.ref = composeRef(this.props.forwardedRef, child.ref);
        var trigger = React.cloneElement(child, cloneProps);
        return trigger;
    };
    return Trigger;
}(React.Component));
export default Trigger;
